import { Icon } from "icons";
import { type ReactNode } from "react";
import { TabsTrigger, Tooltip, TooltipContent, TooltipTrigger } from "ui";

interface MainAlternateTabProps {
  value: string;
  mainLabel: string;
  children: ReactNode;
}

// The main tab of an alternates tab strip, marked with a star.
export function MainAlternateTab(props: MainAlternateTabProps) {
  return (
    <TabsTrigger value={props.value}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Icon
            name="tabler-filled-star"
            size={14}
            className="text-yellow-400"
            aria-label={props.mainLabel}
          />
        </TooltipTrigger>
        <TooltipContent>{props.mainLabel}</TooltipContent>
      </Tooltip>
      {props.children}
    </TabsTrigger>
  );
}
